module.exports = __webpack_public_path__ + "img/banner3.b3d49b6d.png";